module.exports = __webpack_public_path__ + "static/img/erweimanews.7170ff96.png";